import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";
 
const LeadsTable = () => {
  return (
    <Box sx={{ marginTop: 4 }}>
      <Typography variant="h6">LEADS</Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>First Name</TableCell>
              <TableCell>Surname</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Mobile</TableCell>
              <TableCell>Address</TableCell>
              <TableCell>Call Notes</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>John</TableCell>
              <TableCell>Smith</TableCell>
              <TableCell>John@email.com</TableCell>
              <TableCell>09123456789</TableCell>
              <TableCell>1 Zed St, Metropolis</TableCell>
              <TableCell>Purchased a Bed</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
 
const DealListTable = () => {
  return (
    <Box sx={{ marginTop: 4 }}>
      <Typography variant="h6">DEAL LIST</Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>First Name</TableCell>
              <TableCell>Surname</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Mobile</TableCell>
              <TableCell>Date Initiated</TableCell>
              <TableCell>Days Elapsed</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>John</TableCell>
              <TableCell>Smith</TableCell>
              <TableCell>John@email.com</TableCell>
              <TableCell>09123456789</TableCell>
              <TableCell>12/07/2024</TableCell>
              <TableCell>10</TableCell>
              <TableCell>Inflight</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
 
export { LeadsTable, DealListTable };
 